// Auto-generated enum file. Do not edit directly.
// For regenerate run command: yarn generate-icons

export enum IconType {
  Ach = 'Ach',
  AddFile = 'AddFile',
  Address = 'Address',
  ADP = 'ADP',
  Agent = 'Agent',
  AgentSuggestion = 'AgentSuggestion',
  AiAgentDot = 'AiAgentDot',
  AiAgentIndicator = 'AiAgentIndicator',
  AiAgentTopbar = 'AiAgentTopbar',
  AiSparkle = 'AiSparkle',
  AllPayments = 'AllPayments',
  AllTasks = 'AllTasks',
  Amex = 'Amex',
  Amount = 'Amount',
  Analyst = 'Analyst',
  Api = 'Api',
  Apple = 'Apple',
  Approve = 'Approve',
  Approved = 'Approved',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  ArrowUp = 'ArrowUp',
  Avatar = 'Avatar',
  Bank = 'Bank',
  Bill = 'Bill',
  Built = 'Built',
  BusinessDirectory = 'BusinessDirectory',
  BusinessLocation = 'BusinessLocation',
  BusinessName = 'BusinessName',
  BusinessNumber = 'BusinessNumber',
  BusinessType = 'BusinessType',
  Calendar = 'Calendar',
  CapitalOne = 'CapitalOne',
  Card = 'Card',
  CardSimilarDataApproved = 'CardSimilarDataApproved',
  Chargebacks = 'Chargebacks',
  Chat = 'Chat',
  ChatNotification = 'ChatNotification',
  ChatNotificationHuge = 'ChatNotificationHuge',
  Check = 'Check',
  ChevronDown = 'ChevronDown',
  ChevronLeft = 'ChevronLeft',
  ChevronLeftEnd = 'ChevronLeftEnd',
  ChevronRight = 'ChevronRight',
  ChevronRightEnd = 'ChevronRightEnd',
  ChevronUp = 'ChevronUp',
  Close = 'Close',
  Clover = 'Clover',
  Collapse = 'Collapse',
  Company = 'Company',
  ComplyAdvantage = 'ComplyAdvantage',
  ContactBusinessLocation = 'ContactBusinessLocation',
  ContactDetails = 'ContactDetails',
  ContactNumber = 'ContactNumber',
  Copy = 'Copy',
  CreditDirection = 'CreditDirection',
  CryptoService = 'CryptoService',
  Debit = 'Debit',
  DebitDirection = 'DebitDirection',
  Declined = 'Declined',
  Description = 'Description',
  Desktop = 'Desktop',
  DMLinking = 'DMLinking',
  DMMoneyReceive = 'DMMoneyReceive',
  DuckduckGo = 'DuckduckGo',
  Edit = 'Edit',
  EditorDashboard = 'EditorDashboard',
  EditorExternal = 'EditorExternal',
  Ekata = 'Ekata',
  Email = 'Email',
  Enrichment = 'Enrichment',
  Enrolled = 'Enrolled',
  EnrollmentStatus = 'EnrollmentStatus',
  Evolve = 'Evolve',
  Expand = 'Expand',
  Expense = 'Expense',
  ExternalLink = 'ExternalLink',
  Facebook = 'Facebook',
  FileReport = 'FileReport',
  Filter = 'Filter',
  FilterActive = 'FilterActive',
  Financing = 'Financing',
  Fiserv = 'Fiserv',
  FlexCard = 'FlexCard',
  FlowBuilder = 'FlowBuilder',
  FlowMonitoring = 'FlowMonitoring',
  Forest = 'Forest',
  Freebies = 'Freebies',
  Frr = 'Frr',
  FsPyUsd = 'FsPyUsd',
  Gain = 'Gain',
  GBG = 'GBG',
  Github = 'Github',
  GoodsReceived = 'GoodsReceived',
  Google = 'Google',
  Gusto = 'Gusto',
  HasPreviouslyApprovedPayments = 'HasPreviouslyApprovedPayments',
  HasProhibited = 'HasProhibited',
  HasSanctioned = 'HasSanctioned',
  Help = 'Help',
  Hide = 'Hide',
  HighAmount = 'HighAmount',
  Idm = 'Idm',
  Industry = 'Industry',
  Information = 'Information',
  Inspect = 'Inspect',
  International = 'International',
  Invoice = 'Invoice',
  JPM = 'JPM',
  LegalCompanyAddress = 'LegalCompanyAddress',
  LegalCompanyName = 'LegalCompanyName',
  Link = 'Link',
  Linkedln = 'Linkedln',
  Linking = 'Linking',
  Location = 'Location',
  Lock = 'Lock',
  LogIn = 'LogIn',
  LogOut = 'LogOut',
  Loss = 'Loss',
  Mail = 'Mail',
  MasterCard = 'MasterCard',
  Maximine = 'Maximine',
  MelioMe = 'MelioMe',
  Metadata = 'Metadata',
  Mic = 'Mic',
  Minus = 'Minus',
  Mobile = 'Mobile',
  MoneyIn = 'MoneyIn',
  MoneyOut = 'MoneyOut',
  MoreHorizontal = 'MoreHorizontal',
  MoreVertical = 'MoreVertical',
  MsnApproved = 'MsnApproved',
  MsnEnrolled = 'MsnEnrolled',
  MyTasks = 'MyTasks',
  OpenCorporate = 'OpenCorporate',
  OrgEmailVerified = 'OrgEmailVerified',
  OrgOwesMoney = 'OrgOwesMoney',
  OrgStatus = 'OrgStatus',
  OrgTasks = 'OrgTasks',
  PaperClip = 'PaperClip',
  PartnerStatus = 'PartnerStatus',
  Pause = 'Pause',
  Payee = 'Payee',
  PaymentExpedited = 'PaymentExpedited',
  PaymentLimitation = 'PaymentLimitation',
  PaymentLocator = 'PaymentLocator',
  Payor = 'Payor',
  PayorOriginGuest = 'PayorOriginGuest',
  Paypal = 'Paypal',
  PaypalBalance = 'PaypalBalance',
  Payroll = 'Payroll',
  Pending = 'Pending',
  Phone = 'Phone',
  PinEmpty = 'PinEmpty',
  PinFilled = 'PinFilled',
  Plaid = 'Plaid',
  Plus = 'Plus',
  ProhibitedIndustry = 'ProhibitedIndustry',
  Projects = 'Projects',
  Quickbooks = 'Quickbooks',
  QuickView = 'QuickView',
  RecoCustomerFunds = 'RecoCustomerFunds',
  RecoDashboard = 'RecoDashboard',
  RecoDDAClosingReportNoGaps = 'RecoDDAClosingReportNoGaps',
  RecoDDAClosingReportWithGaps = 'RecoDDAClosingReportWithGaps',
  RecoGaps = 'RecoGaps',
  RecoJPMReport = 'RecoJPMReport',
  RecoRevenueAccounts = 'RecoRevenueAccounts',
  RecoTransferSearch = 'RecoTransferSearch',
  RecoVendorBalance = 'RecoVendorBalance',
  RecurringPayment = 'RecurringPayment',
  Redash = 'Redash',
  Refresh = 'Refresh',
  Refund = 'Refund',
  Remove = 'Remove',
  RiskStatus = 'RiskStatus',
  Rpps = 'Rpps',
  Rtp = 'Rtp',
  Sanctions = 'Sanctions',
  Save = 'Save',
  SBB = 'SBB',
  SBC = 'SBC',
  ScanFailed = 'ScanFailed',
  Search = 'Search',
  SearchError = 'SearchError',
  SelfProclaimed = 'SelfProclaimed',
  Send = 'Send',
  Setting = 'Setting',
  ShieldCheck = 'ShieldCheck',
  ShiftManager = 'ShiftManager',
  Shopify = 'Shopify',
  ShopifyWallet = 'ShopifyWallet',
  Show = 'Show',
  Slack = 'Slack',
  SortDefault = 'SortDefault',
  SortDown = 'SortDown',
  SortUp = 'SortUp',
  StrategyBuilder = 'StrategyBuilder',
  StrategyRules = 'StrategyRules',
  Subscription = 'Subscription',
  SUVC = 'SUVC',
  SVB = 'SVB',
  TaxForm = 'TaxForm',
  TestPayment = 'TestPayment',
  ThemeEditor = 'ThemeEditor',
  ThumbDown = 'ThumbDown',
  ThumbUp = 'ThumbUp',
  TierDiscount = 'TierDiscount',
  Trulioo = 'Trulioo',
  UncollectedFunds = 'UncollectedFunds',
  Unlock = 'Unlock',
  UnMatch = 'UnMatch',
  User = 'User',
  UserDeleted = 'UserDeleted',
  UserRemoved = 'UserRemoved',
  VendorApproved = 'VendorApproved',
  Vendors = 'Vendors',
  VirtualCard = 'VirtualCard',
  Visa = 'Visa',
  Warning = 'Warning',
  Web = 'Web',
  WellsFargo = 'WellsFargo',
  Wire = 'Wire',
  Xero = 'Xero',
  Zendesk = 'Zendesk',
  ZendeskActionRequired = 'ZendeskActionRequired',
  ZendeskOnHold = 'ZendeskOnHold',
  ZendeskResponded = 'ZendeskResponded',
  Zoominfo = 'Zoominfo',
}